import type { BackgroundJobRow } from "@/lib/db/background-jobs-dal"

const ACTIVE_JOB_STATUSES = new Set<BackgroundJobRow["status"]>(["pending", "running"])

export function findActiveKnowledgeBaseUrlImportJob(
  jobs: BackgroundJobRow[] | undefined,
): BackgroundJobRow | null {
  return jobs?.find((job) => ACTIVE_JOB_STATUSES.has(job.status)) ?? null
}

export function resolveKnowledgeBaseUrlImportJobToWatch(
  watchedJobId: string | null,
  jobs: BackgroundJobRow[] | undefined,
): string | null {
  if (watchedJobId) return watchedJobId
  return findActiveKnowledgeBaseUrlImportJob(jobs)?.id ?? null
}
